export default __webpack_public_path__ + "static/media/icon-fiche-patient.e3be6ce8.svg";